import React, {useEffect} from 'react';
import {observer} from "mobx-react-lite";
import {useStore} from "@/app/providers/StoreProvider";
import {RatingList} from "@/entities/rating/ui/RatingList";
import {TeamList} from "@/entities/team/ui/TeamList";
import {Loading} from "@/shared/ui/Loading";

export const RatingLists = observer(() => {
    const {ratingStore} = useStore();

    const {currentTab,loading} = ratingStore;
    useEffect(() => {
        ratingStore.getRating(currentTab);
    }, [currentTab]);

    if (loading) return <Loading/>;
    return (
        currentTab === "USER_GLOBAL"
                ?<RatingList/>
                :<TeamList/>

    );
});
